import { Flex, Typography } from '@aloft/toolkit-sui';

export function NoMlsDataTooltip() {
  return (
    <Flex padding="1rem" alignContent="center">
      <Typography>No listing information available</Typography>
    </Flex>
  );
}
